import { render, staticRenderFns } from "./cg-event-navigation.vue?vue&type=template&id=6c5cfff2&scoped=true"
import script from "./cg-event-navigation.vue?vue&type=script&lang=js"
export * from "./cg-event-navigation.vue?vue&type=script&lang=js"
import style0 from "./cg-event-navigation.vue?vue&type=style&index=0&id=6c5cfff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5cfff2",
  null
  
)

export default component.exports